var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Headings"}},[(_vm.className==='white_color')?_c('div',{staticClass:"title white_color"},[_c('p',[_vm._v(_vm._s(_vm.data))])]):_c('div',{staticClass:"title blue_color"},[_c('p',[_vm._v(_vm._s(_vm.data))])])])}
var staticRenderFns = []

export { render, staticRenderFns }